// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const disabledStyle = {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[200]
    }
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          whiteSpace: 'nowrap',
          borderRadius: '.4rem',
          width: 'auto',
          // '&:hover': {
          //   backgroundImage: theme.palette.gradient.primary,
          //   color: '#fff'
          // },
          '&.Mui-disabled': {
            backgroundImage: 'none',
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: 'rgba(0, 0, 0, 0.26)'
          },
          '&button, &[type="button"], &[type="reset"], &[type="submit"]': {
            backgroundColor: 'tertiary.main',
            color: '#fff',
            backgroundImage: 'none'
            // Add any other styles you want
          }
        },
        contained: {
          ...disabledStyle
        },
        outlined: {
          ...disabledStyle
        }
      }
    }
  };
}
